class FixedATC extends HHBaseElement {
  constructor() {
    super()

    this.footer = document.querySelector('footer')
    this.addToCartToggle = this.querySelector(
      '.fixed-add-to-cart__button-container button'
    )

    this.productDetailsSection = document.querySelector(
      '.single-product__details'
    )

    this.mobileAddToCartButton = document.querySelector(
      '.atc-container.mobile-sticky'
    )

    this._addToCart = this._addToCart.bind(this)
    this._handleScrolling = this._handleScrolling.bind(this)
    this._clearMobileStyles = this._clearStickyStyles.bind(this)

    this.mql = window.matchMedia('(min-width: 992px)')
  }

  connectedCallback() {
    this._attachListeners()
    this._handleScrolling()
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  _attachListeners() {
    document.addEventListener('scroll', this._handleScrolling, {
      passive: true,
    })
    if (this.addToCartToggle) {
      this.addToCartToggle.addEventListener('click', this._addToCart)
    }

    window.addEventListener('resize', this._clearMobileStyles)
  }

  _removeListeners() {
    document.removeEventListener('scroll', this._handleScrolling)

    window.removeEventListener('resize', this._clearMobileStyles)
    if (this.addToCartToggle) {
      this.addToCartToggle.removeEventListener('click', this._addToCart)
    }
  }

  _handleScrolling(e) {
    let footer = this.footer
    let footerDistanceFromTop =
      window.scrollY + footer.getBoundingClientRect().top - footer.offsetHeight

    if (this.mql.matches) {
      let scrolling = false
      let productDetailsSection = this.productDetailsSection

      if (!scrolling) {
        window.requestAnimationFrame(() => {
          let pdpDetailsDistanceFromTop =
            window.scrollY +
            productDetailsSection.getBoundingClientRect().top +
            productDetailsSection.offsetHeight / 4

          if (
            window.scrollY > pdpDetailsDistanceFromTop &&
            window.scrollY < footerDistanceFromTop
          ) {
            this.style.transform = 'translate3d(0, 0%, 0)'
          } else {
            this.style.transform = 'translate3d(0, 100%, 0)'
          }

          scrolling = false
        })

        scrolling = true
      }
    } else {
      let scrolling = false

      let mobileAtcButton = this.mobileAddToCartButton

      if (!scrolling) {
        window.requestAnimationFrame(() => {
          let mobileStickyAtcDistanceFromTop =
            window.scrollY +
            mobileAtcButton.getBoundingClientRect().top -
            window.innerHeight

          let gutter = parseFloat(
            getComputedStyle(document.documentElement)
              .getPropertyValue('--gutter')
              .replace('px', '')
          )

          let zIndexHighest = getComputedStyle(
            document.documentElement
          ).getPropertyValue('--z-index-highest')

          let containerWidth = getComputedStyle(document.documentElement)
            .getPropertyValue('--container-width')
            .replace('px', '')

          if (window.scrollY > footer.getBoundingClientRect().top) {
            mobileAtcButton.querySelector('.sticky-container').style.transform =
              'translate3d(0, 110%, 0)'
          } else if (
            window.scrollY - gutter >=
            mobileStickyAtcDistanceFromTop + mobileAtcButton.offsetHeight
          ) {
            mobileAtcButton.querySelector('.sticky-container').style.transform =
              'translate3d(0, 0%, 0)'

            mobileAtcButton.querySelector('.sticky-inner').style.paddingLeft =
              gutter + 'px'
            mobileAtcButton.querySelector('.sticky-inner').style.paddingRight =
              gutter + 'px'
            mobileAtcButton.querySelector('.sticky-inner').style.margin =
              '0 auto'

            mobileAtcButton.querySelector('.sticky-inner').style.maxWidth =
              containerWidth + 'px'

            mobileAtcButton.querySelector('.sticky-container').style.position =
              'fixed'
            mobileAtcButton.querySelector('.sticky-container').style.bottom = 0
            mobileAtcButton.querySelector('.sticky-container').style.left = 0
            mobileAtcButton.querySelector('.sticky-container').style.width =
              '100%'
            mobileAtcButton.querySelector(
              '.sticky-container'
            ).style.backgroundImage =
              'linear-gradient(180deg, rgba(255, 251, 247, 0) 0%, #fffbf7 100%)'
            mobileAtcButton.querySelector('.sticky-container').style.zIndex =
              Number(zIndexHighest) - 1
            mobileAtcButton.querySelector(
              '.sticky-container'
            ).style.paddingBottom = gutter + 'px'
            mobileAtcButton.querySelector(
              '.sticky-container'
            ).style.transition = 'transform 0.25s'
          } else {
            mobileAtcButton.style.minHeight = 0
            mobileAtcButton.querySelector('.sticky-container').style = ''
            mobileAtcButton.querySelector('.sticky-inner').style = ''
          }

          scrolling = false
        })

        scrolling = true
      }
    }
  }

  _clearStickyStyles() {
    if (this.mql.matches) {
      this.mobileAddToCartButton.style.minHeight = 0
      this.mobileAddToCartButton.querySelector('.sticky-container').style = ''
      this.mobileAddToCartButton.querySelector('.sticky-inner').style = ''

      this.style.transform = 'translate3d(0, 100%, 0)'
    }
  }

  get productId() {
    return this.getAttribute('product-id')
  }

  get product() {
    return JSON.parse(
      window.atob(
        document.querySelector(`#main-product-data-${this.productId}`).innerText
      )
    )
  }

  fillNotifyMeModal(params) {
    const notifyMeImage = document.querySelector('.js-slideout-notify-me-image')
    const notifyMeTitle = document.querySelector('.js-slideout-notify-me-title')
    const notifyMeVariant = document.querySelector(
      '.js-slideout-notify-me-variant'
    )
    const notifyMeSku = document.querySelector('#slideout-notify-me-sku')
    const notifyMeProductId = document.querySelector(
      '#slideout-notify-me-product-id'
    )

    notifyMeImage.innerHTML = `<img src="${params.image}" alt="${params.productTitle}" />`
    notifyMeTitle.innerHTML = params.productTitle
    if (params.title.toLowerCase() === 'default title') {
      notifyMeVariant.innerHTML = ''
    } else {
      notifyMeVariant.innerHTML = `${
        params.hexCode &&
        `<span class="block" style="background-color: ${params.hexCode};"></span>`
      }${params.title}`
    }
    notifyMeSku.value = params.sku
    notifyMeProductId.value = params.productId
    const notifyMeVariantId = document.querySelector('#slideout-notify-me-variant-id')
    if (notifyMeVariantId) notifyMeVariantId.value = params.variantId
  }

  async _addToCart(e) {
    e.preventDefault()
    const triggerButton = e.currentTarget
    const selectedVariantId = document.querySelector('.selected-variant')
    const hexcode = document.querySelector('.js-selected-variant-hex')
    const isNotifyMe =
      triggerButton.classList.contains(atcStatusTitle.notifyMeClass[0]) === true
    if (isNotifyMe) {
      let selectedItem = null
      this.product.variants.forEach((item) => {
        if (Number(selectedVariantId.value) === item.id) {
          selectedItem = item
        }
      })
      const params = {
        productId: this.product.id,
        variantId: selectedVariantId.value,
        productTitle: document.querySelector('.product-header__product-title')
          .innerHTML,
        sku: selectedItem?.sku,
        title: selectedItem?.title,
        image: selectedItem?.featured_image
          ? selectedItem?.featured_image.src
          : this.product.featured_image,
        hexCode: hexcode?.value || '',
      }
      this.fillNotifyMeModal(params)
    } else {
      if (triggerButton) {
        triggerButton.setAttribute('loading', true)
      }
      const body = {
        id: selectedVariantId.value,
        quantity: 1,
      }
      if (hexcode) {
        body['properties'] = {}
        body['properties']['_hex'] = hexcode?.value
      }

      try {
        await window.__CART__CONTROLLER__.add([body])
      } finally {
        triggerButton.removeAttribute('loading')
      }
    }
  }
}
window.customElements.define('fixed-atc', FixedATC)
